import apiClient from './client';

// Auth endpoints
export const authAPI = {
  signup: async (data) => {
    const response = await apiClient.post('/auth/signup', data);
    return response.data;
  },
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password });
    return response.data;
  },
  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
  logout: async () => {
    const response = await apiClient.post('/auth/logout');
    return response.data;
  },
  checkUsername: async (username) => {
    const response = await apiClient.get(`/auth/check-username?username=${encodeURIComponent(username)}`);
    return response.data;
  },
};

// Profile endpoints
export const profileAPI = {
  getProfile: async () => {
    const response = await apiClient.get('/profile');
    return response.data;
  },
  updateProfile: async (updates) => {
    const response = await apiClient.put('/profile', updates);
    return response.data;
  },
};

// Swipe endpoints
export const swipeAPI = {
  getProfiles: async (limit = 10) => {
    const response = await apiClient.get(`/swipe/profiles?limit=${limit}`);
    return response.data;
  },
  swipe: async (targetUserId, direction) => {
    const response = await apiClient.post('/swipe', {
      target_user_id: targetUserId,
      direction,
    });
    return response.data;
  },
};

// Match endpoints
export const matchAPI = {
  getMatches: async () => {
    const response = await apiClient.get('/matches');
    return response.data;
  },
};

// Message endpoints
export const messageAPI = {
  getMessages: async (matchUserId) => {
    const response = await apiClient.get(`/messages/${matchUserId}`);
    return response.data;
  },
  sendMessage: async (matchUserId, text) => {
    const response = await apiClient.post(`/messages/${matchUserId}`, { text });
    return response.data;
  },
  setTyping: async (matchUserId) => {
    const response = await apiClient.post(`/messages/${matchUserId}/typing`);
    return response.data;
  },
};
